var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6445 4.62821L14.4548 0.439461C14.3155 0.300137 14.1502 0.189617 13.9681 0.114213C13.7861 0.03881 13.5911 0 13.394 0C13.197 0 13.0019 0.03881 12.8199 0.114213C12.6379 0.189617 12.4726 0.300137 12.3333 0.439461L0.772947 11.9998C0.633053 12.1386 0.522141 12.3038 0.446659 12.4858C0.371176 12.6678 0.33263 12.863 0.33326 13.0601V17.2498C0.33326 17.6476 0.491295 18.0291 0.772599 18.3104C1.0539 18.5917 1.43543 18.7498 1.83326 18.7498H17.5833C17.7822 18.7498 17.9729 18.6708 18.1136 18.5301C18.2542 18.3895 18.3333 18.1987 18.3333 17.9998C18.3333 17.8009 18.2542 17.6101 18.1136 17.4694C17.9729 17.3288 17.7822 17.2498 17.5833 17.2498H8.14451L18.6445 6.74977C18.7838 6.61048 18.8944 6.44511 18.9698 6.2631C19.0452 6.08109 19.084 5.886 19.084 5.68899C19.084 5.49198 19.0452 5.2969 18.9698 5.11489C18.8944 4.93288 18.7838 4.7675 18.6445 4.62821ZM6.02295 17.2498H1.83326V13.0601L10.0833 4.81009L14.2729 8.99977L6.02295 17.2498ZM15.3333 7.93946L11.1445 3.74977L13.3945 1.49977L17.5833 5.68946L15.3333 7.93946Z",
    fill: "#636366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0f3fc86da69caf467a735f4d4adfbc63.svg";
export { ForwardRef as ReactComponent };